import { Post, SubscriptionLevel } from '@tribeplatform/gql-client/types'

/** Sets the follow state on a cached post. */
export const followStateUpdater =
  (subscribed: boolean, level?: SubscriptionLevel | null) =>
  (post: Post): Post =>
    post
      ? {
          ...post,
          authMemberProps: {
            ...post.authMemberProps,
            subscribed,
            subscriptionLevel: subscribed ? (level ?? null) : null,
          },
        }
      : post

/** Optimistic auto-follow after a reply; followed posts are left as is. */
export const followedPostUpdater =
  (level: SubscriptionLevel) =>
  (post: Post): Post =>
    post?.authMemberProps?.subscribed
      ? post
      : followStateUpdater(true, level)(post)

/** Root post of a reply, or parentId when unknown. */
export const getRootPostId = (reply: Post, parentId: string): string =>
  reply?.repliedToIds?.[reply.repliedToIds.length - 1] ?? parentId

/** Bumped on every local follow-state change so a stale refresh can be dropped. */
const followStateVersions = new Map<string, number>()

export const getFollowStateVersion = (postId: string): number =>
  followStateVersions.get(postId) ?? 0

export const bumpFollowStateVersion = (postId: string): number => {
  const next = getFollowStateVersion(postId) + 1
  followStateVersions.set(postId, next)
  return next
}
